// assets
import {
    IconTypography,
    IconPalette,
    IconShadow,
    IconWindmill,
    IconLogout,
    IconShare,
    IconGavel,
    IconInfoCircle,
    IconStar
} from '@tabler/icons';

// project imports
import { Logout } from 'utils/User';

// constant
const icons = {
    IconTypography,
    IconPalette,
    IconShadow,
    IconWindmill,
    IconLogout,
    IconShare,
    IconGavel,
    IconInfoCircle,
    IconStar
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const utilities = {
    id: 'utilities',
    title: 'امکانات',
    type: 'group',
    children: [
        {
            id: 'about',
            title: 'درباره‌ی ما',
            type: 'item',
            url: '/about',
            icon: icons.IconInfoCircle,
            breadcrumbs: false
        },
        {
            id: 'gavel',
            title: 'قوانین و مقررات',
            type: 'item',
            url: '/terms',
            icon: icons.IconGavel,
            breadcrumbs: false
        },
        {
            id: 'share',
            title: 'اشتراک‌گذاری برنامه',
            type: 'item',
            url: '/share',
            icon: icons.IconShare,
            breadcrumbs: false
        },
        {
            id: 'rate',
            title: 'امتیاز به برنامه',
            type: 'item',
            url: '/rate',
            icon: icons.IconStar,
            breadcrumbs: false
        },
        {
            id: 'faq',
            title: 'سؤالات متداول',
            type: 'item',
            url: '/faq',
            icon: icons.IconShadow,
            breadcrumbs: false
        },
        {
            id: 'logout',
            title: 'خروج از حساب',
            type: 'item',
            url: '#',
            onClick: Logout,
            icon: icons.IconLogout,
            breadcrumbs: false
        }
        /*
        {
            id: 'icons',
            title: 'خروج از حساب',
            type: 'collapse',
            icon: icons.IconWindmill,
            children: [
                {
                    id: 'tabler-icons',
                    title: 'Tabler Icons',
                    type: 'item',
                    url: '/icons/tabler-icons',
                    breadcrumbs: false
                },
                {
                    id: 'material-icons',
                    title: 'Material Icons',
                    type: 'item',
                    url: '/icons/material-icons',
                    breadcrumbs: false
                }
            ]
        }*/
    ]
};

export default utilities;
